import { useQuery } from '@tanstack/react-query';

import {
  getDocumentsForParty,
  type GetDocumentsForPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function useDocuments(
  partyId: string,
  options?: QueryOptions<GetDocumentsForPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.list(partyId, { noEmails: true }),
    queryFn: async () => {
      const result = await getDocumentsForParty(
        { path: { party_id: partyId } },
        wgApi,
      );

      return result.items.filter((doc) => !doc.tags?.some((t) => t === 'MAIL'));
    },
    ...options,
  });
}
